module.exports = __webpack_public_path__ + "img/memo.9c720697.png";